module.exports = __webpack_public_path__ + "assets/assignment-topic-active.21505825.svg";